import type { RoleType } from './roles';

const DELETE_ALLOWED: readonly RoleType[] = ['super_admin', 'ba_super_admin'];

/**
 * BE gates `DELETE /organizations/:id` with `requireRole('super_admin', 'ba_super_admin')`
 * (organizationRoute.ts:63-69). Mirror that role check on the FE so `ba_admin` never sees
 * the destroy affordance even though they hold `org:update`.
 */
export function canDeleteOrg(role: RoleType | null): boolean {
  return role !== null && DELETE_ALLOWED.includes(role);
}
